import type { JSX } from 'react/jsx-runtime'

import { AppContent } from '@/app-content'
import { ModalProvider } from '@/contexts/modal-context'
import { ErrorBoundary } from '@/components/error-boundary'
import { CasesProvider } from '@/features/cases/contexts/cases-provider'
import { ClientsProvider } from '@/features/clients/contexts/clients-provider'
import { ResearchProvider } from '@/features/research/contexts/research-provider'
import { ProfileProvider } from '@/features/profile/contexts/profile-provider'
import { StaffProvider } from '@/features/team/contexts/staff-context'
import { BillingProvider } from '@/features/financials/contexts/billing-context'
import { CalendarProvider } from '@/features/calendar/contexts/calendar-context'
import { DashboardStatsProvider } from '@/features/dashboard/contexts/dashboard-stats-context'

const App = (): JSX.Element => {
  return (
    <ErrorBoundary>
      <ModalProvider>
        <DashboardStatsProvider>
          <CasesProvider>
            <ClientsProvider>
              <ResearchProvider>
                <ProfileProvider>
                  <CalendarProvider>
                    <BillingProvider>
                      <StaffProvider chamberId={null}>
                        <AppContent />
                      </StaffProvider>
                    </BillingProvider>
                  </CalendarProvider>
                </ProfileProvider>
              </ResearchProvider>
            </ClientsProvider>
          </CasesProvider>
        </DashboardStatsProvider>
      </ModalProvider>
    </ErrorBoundary>
  )
}

export default App
